export default {
  format(token) {
    return token.replace(/"([^"]+(?="))"/g, '$1');
  },
};



// WEBPACK FOOTER //
// ./src/formatters/token.formatter.js